import { render, staticRenderFns } from "./ChangeOfShare.vue?vue&type=template&id=ec651484&scoped=true&"
import script from "./ChangeOfShare.vue?vue&type=script&lang=js&"
export * from "./ChangeOfShare.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfShare.vue?vue&type=style&index=0&id=ec651484&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec651484",
  null
  
)

export default component.exports